import React from 'react';
import { handleNavigate, formatDate, formatIndianCurrency, saveLogEvent } from '../../utils/Utils';

const Regular = ({ el, navigate, customerNumber, labels }) => {
    const onCliclHandler = () => {
        saveLogEvent(
            {
                logLevel: "info",
                statusCode: 200,
                status: "success",
                source: "MCRO",
                message: { trigger: "On click of button Pay next instalment", Page: "Home Page" },
                payload: {
                    trigger: "On click of button Pay next instalment", Page: "Home Page"
                }
            },

        );
        handleNavigate(navigate, `/payment/${customerNumber}`)
    }

    return (
        <div className="bg-green-200 mb-1 text-black p-4 rounded-tl-none rounded-tr-none rounded-b-[15px]">
            <div className="grid grid-cols-2 gap-2 fs-30w">
                <div>{labels.health}</div>
                <div className='justify-self-end'>{el.LoanHealth}</div>
                <div>{labels.customerNumber}</div>
                <div className='justify-self-end'>{customerNumber}</div>
                <div>{labels.mobileNumber}</div>
                <div className="justify-self-end">{el.Mobile}</div>
                <div>{labels.outstandingBalance}</div>
                <div className="justify-self-end">{formatIndianCurrency(el.BalanceOutstanding)}</div>
                <div>{labels.instalmentNumber}</div>
                <div className="justify-self-end">{el.InstalmentNumber}</div>
                <div>{labels.nextDueDate}</div>
                <div className="justify-self-end">{formatDate(el.NextInstalmentDetails.DueDate)}</div>
                <div>{labels.amountDue}</div>
                <div className="justify-self-end text-lg">{formatIndianCurrency(el.NextInstalmentDetails.AmountDue)}</div>
            </div>
            <div className="flex justify-center">
                <button className="mt-4 bg-white text-green-800 px-4 py-2 rounded-lg" onClick={() => { onCliclHandler() }}>
                    {labels.payNextInstallment}
                </button>
            </div>
        </div>
    );
}

export default Regular;
